import React from 'react'
import './Reasons.css'
import image1 from '../../assets/image1.png'
import image2 from '../../assets/image2.png'
import image3 from '../../assets/image3.png'
import image4 from '../../assets/image4.png'
import nb from '../../assets/nb.png'
import adidas from '../../assets/adidas.png'
import nike from '../../assets/nike.png'
import tick from '../../assets/tick.png'

const Reasons = () => {
  return (
    <div className='Reasons' id='reasons'>
      <div className="left-r">
        <img src={image1} alt="" />
        <img src={image2} alt="" />
        <img src={image3} alt="" />
        <img src={image4} alt="" />
      </div>
      <div className="right-r">
        <span className='some-reasons'>Some Reasons</span>
        <div className="why-choose-us">
          <span className='stroke-text'>why </span>
          <span>Choose Us?</span>
        </div>
        
        <div className='details-r'>
          <div className="reason-item">
            <img src={tick} alt="tick icon" />
            <span>OVER 140+ EXPERT COACHES</span>
          </div>
          <div className="reason-item">
            <img src={tick} alt="tick icon" />
            <span>TRAIN SMARTER AND FASTER THAN BEFORE</span>
          </div>
          <div className="reason-item">
            <img src={tick} alt="tick icon" />
            <span>1 FREE PROGRAM FOR NEW MEMBERS</span>
          </div>
          <div className="reason-item">
            <img src={tick} alt="tick icon" />
            <span>RELIABLE PARTNERS</span>
          </div>
        </div>
        
        <div className="partners-section">
          <span className="partners-heading">OUR PARTNERS</span>
          <div className="partners">
            <img src={nb} alt="New Balance logo" />
            <img src={adidas} alt="Adidas logo" />
            <img src={nike} alt="Nike logo" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Reasons